export enum ActivityObjectTypes {
  PRE_START_SCREEN = 'PRE_START_SCREEN',
  START_SCREEN = 'START_SCREEN',
  ENTRY_SURVEY = 'ENTRY_SURVEY',
  VIDEO = 'VIDEO',
  QUESTION = 'QUESTION',
  EXIT_SURVEY = 'EXIT_SURVEY',
  RESULTS_SCREEN = 'RESULTS_SCREEN',
  SUCCESS_CRITERIA = 'SUCCESS_CRITERIA',
}
